import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EMPTY_RICH_TEXT_DOCUMENT, richTextDocumentHasContent, } from "@diality/contracts";
import { Button } from "../components/ui/button";
import { BlockLink } from "../render/context";
import { RichTextDocumentView } from "./rich-text";
/**
 * The promo itself, without block chrome — so a component harness renders
 * exactly what a page renders.
 *
 * Every part carries its own hook, and that is not decoration: the eyebrow
 * "Patients & Education" is a SUBSTRING of the call-to-action label "Visit
 * Patients & Education", so a page-scoped text search would pass against a
 * renderer that dropped the eyebrow entirely. `compose-promo.spec.ts` reads each
 * field through its own hook and compares exactly.
 *
 * The title is an `<h2>`, asserted. A Promo closes a page it did not open, so it
 * belongs in the outline BELOW whatever opened it — never an `<h1>`.
 *
 * `data-promo-renderer` is deliberately NOT here: it belongs to the harness
 * route. The driver counts that attribute page-wide to decide whether a visitor
 * navigated away, so a destination page carrying a Promo must not answer to it.
 */
export function PromoView({ data }) {
    return (_jsxs("div", { className: "flex w-full max-w-[1054px] flex-col items-center gap-[14px] text-center text-foreground @min-[901px]:gap-0", children: [data.eyebrow && (_jsx("p", { "data-promo-eyebrow": true, className: "type-eyebrow-lg @min-[901px]:mb-4", children: data.eyebrow })), _jsx("h2", { "data-promo-title": true, className: "max-w-[1054px] text-balance font-display text-brand-blue text-[clamp(40px,12cqw,56px)] font-light leading-[1.04] tracking-[-0.02em] @min-[901px]:mb-2 @min-[901px]:text-[clamp(36px,4.444cqw,64px)]", children: data.title }), richTextDocumentHasContent(data.description) && (_jsx("div", { "data-promo-description": true, className: "max-w-[696px] @min-[901px]:mb-4", children: _jsx(RichTextDocumentView, { document: data.description, className: "font-body text-[17px] font-light leading-[1.55] @min-[901px]:text-xl [&_p:first-child]:mt-0 [&_p:last-child]:mb-0 [&_strong]:font-bold" }) })), data.cta.label && data.cta.href && (_jsx("div", { "data-promo-cta": true, children: _jsx(Button, { asChild: true, children: _jsx(BlockLink, { href: data.cta.href, children: data.cta.label }) }) }))] }));
}
/**
 * PromoBlock — the centered Patients & Education endcap from the homepage.
 * The paragraph and button remain optional CMS fields, without changing the
 * component into a different visual treatment when either is omitted.
 */
export function PromoBlock({ data }) {
    return (_jsx("section", { className: "relative z-[2] flex w-full items-center justify-center px-[6.667cqw]", children: _jsx(PromoView, { data: data }) }));
}
export function promoFromBlock(block, _resolve) {
    const scalars = block.scalars ?? {};
    return {
        eyebrow: scalars.eyebrow?.trim() ?? "",
        title: scalars.title ?? "",
        description: block.documents?.description ?? EMPTY_RICH_TEXT_DOCUMENT,
        cta: {
            label: scalars.ctaLabel?.trim() ?? "",
            href: scalars.ctaHref?.trim() ?? "",
        },
    };
}
export const promoBlockEntry = {
    Component: PromoBlock,
    fromBlock: promoFromBlock,
};
//# sourceMappingURL=promo.js.map